<template>
  <div class="navbar-horizontal navbar navbar-dark bg-primary align-items-center">
    <ul class="navbar-nav flex-row w-100">
      <li class="nav-item">
        <QuicksearchComponent v-on="$listeners"/>
      </li>

      <li v-for="(navbarItem, index) in localItems" :key="index" class="nav-item"
          :class="{'ml-auto': index===0, notification:navbarItem.notification, 'nav-item__dropdown-open':navbarItem.showDropdown}"
          @click="onClick(index)">
        <v-icon>{{ navbarItem.icon }}</v-icon>
        <div @click.stop v-if="navbarItem.dropdown" class="dropdown" v-show="navbarItem.showDropdown"
             v-click-outside="{
                handler: () => onClickOutside(index),
                closeConditional: () => navbarItem.showDropdown
            }">
          <slot :name="navbarItem.dropdown" v-bind:close="()=>onClickOutside(index)"></slot>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {ref, watch, toRefs} from '@vue/composition-api'

import QuicksearchComponent from "@/components/form/QuicksearchComponent";

export default {
  name: 'NavBar',
  props: {
    items: Array
  },
  components: {
    QuicksearchComponent
  },
  setup(props) {

    const localItems = ref(props.items.map(item => {
      return {...item, showDropdown: false}
    }))
    watch(toRefs(props).items, () => {
      localItems.value = props.items.map(item => {
        return {...item, showDropdown: false}
      })
    })

    function onClick(index) {
      if (typeof localItems.value[index].onClick !== 'undefined') {
        localItems.value[index].onClick()
      }
      if (typeof localItems.value[index].dropdown !== 'undefined') {
        localItems.value[index].showDropdown = true
      }
    }

    function onClickOutside(index) {
      localItems.value[index].showDropdown = false
    }

    return {
      localItems,
      onClick,
      onClickOutside
    }
  }
}
</script>

<style lang="scss">
.v-application {
  .navbar-nav {
    padding-left: 0;
    list-style: none;
  }

  .navbar-horizontal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1050;
    background-color: $primary;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 $spacer * 4 0 $spacer * 8;
    height: $spacer * 4;
    transition: all .2s ease-in-out;

    .navbar-nav {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;

      .nav-item {
        position: relative;
        padding: 0 16px;

        &.notification {
          &::after {
            position: absolute;
            right: 14px;
            bottom: 0;
          }
        }

        &.nav-item__dropdown-open {
          // Arrow
          &::before {
            content: '';
            position: absolute;
            left: 50%;
            bottom: -18px;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 7.5px 12px 7.5px;
            border-color: transparent transparent #e9e9e9 transparent;
            transform: translateX(-50%);
          }
        }

        a.nav-link {
          padding: 8px 0;
          color: $white;
        }

        .dropdown {
          z-index: 1050;
          position: absolute;
          top: 46px;
          right: 0;
          background-color: white;
        }
      }
    }
  }

  // Change padding if menu is open
  .navbar-vertical.show + .navbar-horizontal {
    padding-left: 250px + $spacer * 4;
  }
}
</style>
